(function() {
  document.addEventListener('alpine:init', () => {
    Alpine.data('carousel', () => ({
      currentSlide: 0,
      delay: 1000 * 30, // animation delay for which the slide will stay still
      navBtnClass: '',
      totalSlides: null,
      slideWidth: null,
      scrollLeft: null,
      intervalId: null,
      scrollToSlide(slideNumber) {
        this.$root.scrollTo({ left: slideNumber * this.slideWidth, behavior: "smooth" })
        this.currentSlide = slideNumber
      },
      handleScroll() {
        this.scrollLeft = this.$root.scrollLeft
        for (let index = 0; index < this.totalSlides; index++) {
          if (this.scrollLeft === index * this.slideWidth) this.currentSlide = index;
        }
      },
      nextSlide() {
        this.increaseCurrentSlide()
        this.$root.scrollTo({ left: this.currentSlide * this.slideWidth, behavior: "smooth" })
        this.scrollToImageButton()
      },
      prevSlide() {
        this.decreaseCurrentSlide()
        this.$root.scrollTo({ left: this.currentSlide * this.slideWidth, behavior: "smooth" })
        this.scrollToImageButton()
      },
      scrollToImageButton() {
        const productDisplay = this.$root.closest("[x-data='productDisplay']")
        if (productDisplay == undefined) return;
        const imageNavigationButtons = productDisplay.querySelectorAll("#imageNavigationButtons button")
        const imageButtonToActivate = imageNavigationButtons[this.currentSlide]
        imageButtonToActivate.parentElement.scrollTo({ top: imageButtonToActivate.offsetTop })
        const productDisplayData = Alpine.$data(productDisplay)
        productDisplayData.currentImageIndex = this.currentSlide
      },
      init() {
        this.totalSlides = this.$root.querySelectorAll("[data-slide]").length
        this.slideWidth = this.$root.scrollWidth / this.totalSlides

        // if the dataset attribute data-disable-auto-scroll is present the value will be '' (empty string)
        // otherwise undefined
        if (this.$root.dataset.disableAutoScroll == undefined) {
          this.intervalId = setInterval(() => {
            this.increaseCurrentSlide()
            this.$root.scrollTo({ left: this.currentSlide * this.slideWidth, behavior: "smooth" })
          }, this.delay);
        }
      },
      destroy() {
        clearInterval(this.intervalId)
      },
      increaseCurrentSlide() {
        this.currentSlide = (this.currentSlide + 1) % this.totalSlides
      },
      decreaseCurrentSlide() {
        if (this.currentSlide - 1 < 0) {
          this.currentSlide = this.totalSlides - 1
        } else {
          this.currentSlide -= 1
        }
      }
    }))

    Alpine.data('sticky', () => ({
      isSticky: false,
      offset: 10,
      handleScroll() {
        this.isSticky = window.pageYOffset > this.$root.scrollHeight + this.offset
      }
    }))

    Alpine.data('overlay', () => ({
      isOpen: false,
      handleOpen() {
        this.isOpen = true
      },
      handleClose() {
        this.isOpen = false
      }
    }))

    Alpine.data('dynamicImage', () => ({
      src: null,
      originalSrc: null,
      windowWidth: null,
      bigDeviceImageSize: 1000,
      init() {
        this.originalSrc = this.$root.src
        this.windowWidth = window.innerWidth
        if (this.windowWidth > 600) {
          let newSrc;
          if (this.$root.dataset.bigDeviceImageSize != undefined) {
            newSrc = this.$root.src.split("&")[0] + "&width=" + +this.$root.dataset.bigDeviceImageSize
          } else {
            newSrc = this.$root.src.split("&")[0] + "&width=" + this.bigDeviceImageSize
          }
          this.$root.src = newSrc
        }
      }
    }))

    Alpine.data('share', () => ({
      show: false,
      didCopy: false,
      timeoutId: null,
      delay: 1000,
      hide() { this.show = false },
      copyToClipboard() {
        navigator.clipboard.writeText(window.location.href)
          .then(() => {
            this.didCopy = true
            this.show = false
            if (this.timeoutId != null) clearTimeout(this.timeoutId);
            setTimeout(() => {
              this.didCopy = false
            }, this.delay);
          })
          .catch(err => {
            console.error('Failed to copy: ', err);
          })
      }
    }))

    Alpine.data('productListing', () => ({
      init() {
        const links = this.$root.querySelector('[data-pagination-container]')?.querySelectorAll("a");
        if (links == undefined) return;
        const sectionId = this.$root.dataset.sectionId
        links.forEach(link => link.addEventListener("click", (e) => {
          e.preventDefault()
          const url = new URL(link.href)
          url.searchParams.set("sections", sectionId)
          fetch(url.href)
            .then(response => response.json())
            .then(data => {
              const tempDiv = document.createElement("div")
              tempDiv.innerHTML = data[sectionId]
              this.$root.innerHTML = tempDiv.querySelector("[x-data='productListing']")?.innerHTML
              url.searchParams.delete("sections")
              window.history.pushState({}, "", url.href)
            })
        }))
      }
    }))

    Alpine.data('productDisplay', () => ({
      currentImageIndex: 0,
      handleClick(num) {
        const allSlides = this.$root.querySelector("#imageGallery").querySelectorAll("[data-slide]")
        allSlides[num].scrollIntoViewIfNeeded()
        this.currentImageIndex = num
        const carousel = this.$root.querySelector("[x-data='carousel']")
        const carouselData = Alpine.$data(carousel)
        carouselData.currentSlide = num
      },
      handleDynamicLinkClick(e) {
        e.preventDefault()
        const imageNavigationButtons = this.$root.querySelectorAll("#imageNavigationButtons button")
        const lastImageIndex = imageNavigationButtons.length - 1
        const imageButtonToActivate = imageNavigationButtons[lastImageIndex]
        imageButtonToActivate.parentElement.scrollTo({ top: imageButtonToActivate.offsetTop })
        this.currentImageIndex = lastImageIndex
        const carousel = this.$root.querySelector("[x-data='carousel']")
        const carouselData = Alpine.$data(carousel)
        carouselData.currentSlide = lastImageIndex
      },
      init() {
      }
    }))

    Alpine.data('sizeNavigationButtons', () => ({
      handleClick(e) {
        e.preventDefault()
        this.scrollToLastImage(e)
      },
      scrollToLastImage(e) {
        const imageNavigationButtons = document.querySelectorAll("#imageNavigationButtons button")
        const imageNavigationButtonsLength = imageNavigationButtons.length
        const { orientationSwatch } = e.target.dataset
        let imageButtonToActivate;
        if (orientationSwatch != null) {
          imageButtonToActivate = imageNavigationButtons[imageNavigationButtonsLength - 2]
        } else {
          imageButtonToActivate = imageNavigationButtons[imageNavigationButtonsLength - 1]
        }
        imageButtonToActivate.click()
        imageButtonToActivate.closest("#imageNavigationButtons").scrollTo({ top: imageButtonToActivate.offsetTop })
      },
      handleDynamicLinkClick(e) {
        const { sectionId } = this.$root.dataset
        const priceSection = document.querySelector("[data-price-section]")
        e.preventDefault()
        const url = new URL(e.target.href)
        url.searchParams.set("sections", sectionId)
        fetch(url.href)
          .then(response => response.json())
          .then(data => {
            this.scrollToLastImage(e)
            const tempDiv = document.createElement("div")
            tempDiv.innerHTML = data[sectionId]
            const priceSectionFromRemote = tempDiv.querySelector("[data-price-section]")
            const sizeNavigationButtonsFromRemote = tempDiv.querySelector("[x-data='sizeNavigationButtons']")
            priceSection.innerHTML = priceSectionFromRemote.innerHTML
            this.$root.innerHTML = sizeNavigationButtonsFromRemote.innerHTML
            url.searchParams.delete("sections")
            window.history.pushState({}, "", url.href)
          })
      }
    }))
  })

  class VCartActions extends HTMLElement {
    url = Shopify.routes.root + "cart/change.js"
    constructor() {
      super()
    }

    connectedCallback() {
      this.plusButton = this.querySelector("[data-plus-button]")
      this.minusButton = this.querySelector("[data-minus-button]")
      this.removeButton = this.querySelector("[data-remove-button]")
      this.sizeSelector = this.querySelector("[data-size-selector]")
      this.qtyInput = this.querySelector("[data-qty-input]")
      this.itemId = this.dataset.itemId
      this.variantId = this.dataset.variantId
      this.specialNote = this.querySelector(`textarea[name="properties[Special Note]"]`)

      this.plusButton?.addEventListener("click", this.handlePlusClick.bind(this))
      this.minusButton?.addEventListener("click", this.handleMinusClick.bind(this))
      this.removeButton?.addEventListener("click", this.handleRemoveClick.bind(this))
      this.sizeSelector?.addEventListener("change", this.handleSizeChange.bind(this))
      this.qtyInput?.addEventListener("change", this.handleQtyChange.bind(this))
      if (this.specialNote != undefined) {
        this.specialNote.addEventListener("change", this.handleSpecialNoteChange.bind(this))
      }
    }

    disconnectedCallback() {
      this.plusButton?.removeEventListener("click", this.handlePlusClick.bind(this))
      this.minusButton?.removeEventListener("click", this.handleMinusClick.bind(this))
      this.removeButton?.removeEventListener("click", this.handleRemoveClick.bind(this))
      this.sizeSelector?.removeEventListener("change", this.handleSizeChange.bind(this))
      this.qtyInput?.removeEventListener("change", this.handleQtyChange.bind(this))
    }

    handlePlusClick() {
      const currentQty = +this.qtyInput?.value
      const formData = {
        id: this.itemId,
        quantity: currentQty + 1,
        sections: 'cart-section,cart-icon-section'
      }

      this.updateCart(formData)
    }

    handleMinusClick() {
      const currentQty = +this.qtyInput?.value
      const formData = {
        id: this.itemId,
        quantity: currentQty - 1,
        sections: 'cart-section,cart-icon-section'
      }

      this.updateCart(formData)
    }

    handleRemoveClick() {
      const formData = {
        id: this.itemId,
        quantity: 0,
        sections: 'cart-section,cart-icon-section'
      }

      this.updateCart(formData)
    }

    handleSizeChange(e) {
      const dataToDeleteCurrentItem = {
        id: this.itemId,
        quantity: 0
      }

      const formData = {
        id: e.target.value,
        quantity: +this.qtyInput?.value,
        sections: 'cart-section,cart-icon-section'
      }

      if (this.specialNote) {
        formData.properties = {
          "Special Note": this.specialNote.value
        }
      }

      fetch(this.url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(dataToDeleteCurrentItem)
      })
        .then(response => {
          if (response.ok) this.updateCart(formData, Shopify.routes.root + "cart/add.js");
        })
    }

    handleQtyChange() {
      const formData = {
        id: this.itemId,
        quantity: +this.qtyInput.value,
        sections: 'cart-section,cart-icon-section'
      }
      this.updateCart(formData)
    }

    handleSpecialNoteChange(e) {
      const formData = {
        id: this.itemId,
        properties: {
          "Special Note": e.target.value
        },
        sections: 'cart-section,cart-icon-section'
      }

      this.updateCart(formData)
    }

    updateCart(formData, url = this.url) {
      fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(formData)
      })
        .then(response => response.json())
        .then(data => {
          formData.sections.split(",").forEach(sectionId => {
            let elWithSectionId = document.querySelector(`[data-section-id="${sectionId}"]`)
            elWithSectionId.parentElement.outerHTML = data.sections[sectionId]
          })
        })
    }
  }

  customElements.define("v-cart-actions", VCartActions)

  class VDiscount extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      this.form = this.querySelector("form")
      this.form.addEventListener("submit", this.handleSubmit.bind(this))
      this.discountInput = this.querySelector(`input[name="discount"]`)
      this.removeDiscountButton = this.querySelector("[data-remove-discount-button]")
      this.removeDiscountButton?.addEventListener("click", this.handleRemoveDiscountClick.bind(this))
    }

    handleSubmit(e) {
      e.preventDefault()
      const formData = {
        discount: this.discountInput?.value.trim(),
        sections: 'cart-section'
      }
      this.updateDiscount(formData)
    }

    updateDiscount(formData) {
      const invalidCouponPara = this.querySelector("[data-coupon-invalid-para]")
      invalidCouponPara?.remove()

      fetch(Shopify.routes.root + "cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(formData)
      })
        .then(response => {
          return response.json()
        })
        .then(data => {
          const cartSection = document.querySelector(`[data-section-id="${formData.sections}"]`)
          cartSection.parentElement.outerHTML = data.sections[formData.sections]
          const newVDiscount = document.querySelector("v-discount")
          const form = newVDiscount.querySelector("form")

          if (data.discount_codes.length > 0 && data.total_discount === 0) {
            const invalidCouponPara = document.createElement("p")
            invalidCouponPara.innerText = `${this.discountInput.value.toUpperCase()} is not a valid Coupon or your order doesn't qualify.`
            invalidCouponPara.className = "text-rose-500 text-sm"
            invalidCouponPara.setAttribute("data-coupon-invalid-para", "")
            form.after(invalidCouponPara)
            // newVDiscount.appendChild(invalidCouponPara)
          }
        })
    }

    handleRemoveDiscountClick() {
      const formData = {
        discount: "",
        sections: 'cart-section'
      }
      this.updateDiscount(formData)
    }
  }

  customElements.define("v-discount", VDiscount)

  class VPaginationOld extends HTMLElement {
    constructor() {
      super()
    }

    get sectionId() {
      return this.dataset.sectionId
    }

    connectedCallback() {
      this.links = Array.from(this.querySelectorAll('[data-pagination-container] a'))
      this.links.forEach(link => {
        link.addEventListener("click", this.updateProductList.bind(this))
      })

    }

    updateProductList(e) {
      e.preventDefault()
      const url = new URL(e.currentTarget?.href)
      url.searchParams.set("sections", this.sectionId)
      fetch(url.href)
        .then(response => response.ok ? response.json() : console.log("Something went wrong"))
        .then(data => {
          this.parentElement.outerHTML = data[this.sectionId]
          url.searchParams.delete("sections")
          window.history.pushState({}, "", url.href)
          const newVPagination = document.querySelector("v-pagination")
          newVPagination ? newVPagination.scrollIntoView({ behavior: "smooth" }) : document.documentElement.scrollIntoView({ behavior: "smooth" })
        })
        .catch(err => {
          console.log("Somethign went wrong!", err.message)
        })
    }

    disconnectedCallback() {
      this.links?.forEach(link => {
        link.removeEventListener("click", this.updateProductList.bind(this))
      })
    }
  }

  class VPagination extends HTMLElement {
    constructor() {
      super()
      this.loading = false;
      this.trigger = null;
      this.observer = null;
      this.parser = new DOMParser()
    }

    get sectionId() {
      return this.dataset.sectionId
    }

    connectedCallback() {
      this.productGallery = this.querySelector("div#product-gallery")
      this.links = Array.from(this.querySelectorAll('[data-pagination-container] a'))
      this.links.forEach(link => {
        link.addEventListener("click", this.updateProductList.bind(this))
      })

      this.trigger = this.querySelector("div#infinite-scroll-trigger")
      if (this.trigger) {
        this.observer = new IntersectionObserver(entries => {
          if (!entries[0] || this.loading) return;
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.updateProductList()
            }
          })
        })
        this.observer.observe(this.trigger)
      }
    }

    updateProductList() {
      // const url = new URL(this.trigger.dataset.nextUrl)
      // url.searchParams.set("sections", this.sectionId)
      // url.searchParams.delete("sections")
      // window.history.pushState({}, "", url.href)
      const url = this.trigger.dataset.nextUrl;
      if (!url) return;

      this.loading = true;

      (async () => {
        const response = await fetch(url)
        if (!response.ok) {
          console.log("Something went wrong");
          return;
        }
        this.trigger.remove();
        const html = await response.text();
        const doc = this.parser.parseFromString(html, "text/html");
        const newProducts = doc.querySelectorAll("v-pagination > div#product-gallery article.product");
        const newTrigger = doc.querySelector("v-pagination > div#infinite-scroll-trigger")
        this.productGallery.append(...newProducts)
        if (!newTrigger) return;

        this.productGallery.after(newTrigger)
        this.trigger = newTrigger
        this.observer.observe(this.trigger)
        this.loading = false
      })()
    }

    disconnectedCallback() {
      this.links?.forEach(link => {
        link.removeEventListener("click", this.updateProductList.bind(this))
      })
    }
  }

  customElements.define("v-pagination", VPagination);

  class VFilter extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      this.productListPagination = document.querySelector("v-pagination[data-section-id]")
      this.productListPaginationSectionId = this.productListPagination.dataset.sectionId
      this.sectionId = this.dataset.sectionId
      this.filterInputs = this.querySelectorAll("input[type='checkbox'][data-filter-input]")
      this.filterInputs.forEach(checkbox => {
        checkbox.addEventListener("change", this.handleFilterCheckboxChange.bind(this))
      })
    }

    handleFilterCheckboxChange(e) {
      const currentFilterCheckbox = e.currentTarget
      this.productListPagination = document.querySelector("v-pagination[data-section-id]")
      const url = new URL(currentFilterCheckbox.checked ? currentFilterCheckbox.dataset.urlToAdd : currentFilterCheckbox.dataset.urlToRemove, window.location.origin)
      url.searchParams.set("sections", [this.productListPaginationSectionId, this.sectionId].join(","))
      fetch(url)
        .then(response => response.json())
        .then(data => {
          this.productListPagination.parentElement.outerHTML = data[this.productListPaginationSectionId]
          this.parentElement.outerHTML = data[this.sectionId]
          url.searchParams.delete("sections")
          window.history.pushState({}, "", url.href)
          // const details = currentFilterCheckbox.closest("details")
          // details?.removeAttribute("open")
        })
        .catch(err => console.log("Something went wrong!", err.message))
    }

    disconnectedCallback() {
      this.filterInputs.forEach(checkbox => {
        checkbox.removeEventListener("change", this.handleFilterCheckboxChange.bind(this))
      })
    }
  }

  customElements.define("v-filter", VFilter)

  class VPicture extends HTMLElement {
    constructor() {
      super()
    }
    connectedCallback() {
      const landscapeSrc = this.dataset.landscapeSrc
      let landscapeSrcset = ""
      const landscapeAlt = this.dataset.landscapeAlt

      const portraitSrc = this.dataset.portraitSrc
      let portraitSrcset = ""
      const portraitAlt = this.dataset.portraitAlt

      const loading = this.dataset.loading
      const fetchPriority = this.dataset.fetchPriority
      const imgClass = this.dataset.imgClass

      const sizes = [
        200, 250, 300, 350, 400, 450, 500, 600, 650, 700, 800, 900, 1000, 1100, 1200, 1300, 1400, 1500, 1600, 1700, 1800, 1900, 2000, 2400, 2800, 3000
      ]

      for (let index = 0; index < sizes.length; index++) {
        const size = sizes[index]
        landscapeSrcset += `${landscapeSrc}&width=${size} ${size}w`
        portraitSrcset += `${portraitSrc}&width=${size} ${size}w`

        if (index !== size.length) {
          landscapeSrcset += ", "
          portraitSrcset += ", "
        }
      }

      const { width, height } = this.getBoundingClientRect()
      const isLandscape = width > height

      let innerHTML;

      if (isLandscape) {
        innerHTML = `<img
src="${landscapeSrc}"
srcset="${landscapeSrcset}"
alt="${landscapeAlt}"
class="${imgClass}"
sizes="(max-width: 768px) calc(100vw - 32px), (max-width: 1312px) calc(50vw - 42px), 635px"  width="${width}" height="${height}"${loading ? " loading=" + loading : ""}${fetchPriority ? " fetchPriority=" + fetchPriority : ""} />`.trim()
      }
      else {
        innerHTML = `<img
src="${portraitSrc}"
srcset="${portraitSrcset}"
alt="${portraitAlt}"
class="${imgClass}"
sizes="(max-width: 768px) calc(50vw - 42px), (max-width: 1312px) calc(33.33 - 52px), 420px"  width="${width}" height="${height}"${loading ? " loading=" + loading : ""}${fetchPriority ? " fetchPriority=" + fetchPriority : ""} />`.trim()
      }

      this.innerHTML = innerHTML
    }

    disconnectedCallback() {

    }
  }

  customElements.define("v-picture", VPicture)

  class VCarousel extends HTMLElement {
    constructor() {
      super()
      this.handleWindowReisze = this.handleWindowReisze.bind(this)
    }

    connectedCallback() {
      this.firstImage = this.querySelector("img")
      this.firstImageParent = this.firstImage?.parentElement
      this.navigationButtons = [...this.querySelectorAll("button")]
      this.container = this.querySelector("[data-container]")
      this.handleWindowReisze()
      window.addEventListener("resize", this.handleWindowReisze)
    }

    disconnectedCallback() {
      window.removeEventListener("resize", this.handleWindowReisze)
    }

    handleWindowReisze() {
      if (this.firstImageParent == undefined) { return };
      if (this.container == undefined) { return };
      const display = getComputedStyle(this.container).display
      if (display === "none") { return };

      this.imageWidthHalf = this.firstImageParent.getBoundingClientRect().width / 2
      this.navigationButtons?.forEach(button => button.style.top = this.imageWidthHalf + "px")
    }
  }

  customElements.define("v-carousel", VCarousel)

  class VNestedMenu extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      this.detailsEl = this.querySelector("details");
      this.handlePointerEnter = this.handlePointerEnter.bind(this)
      this.handlePointerLeave = this.handlePointerLeave.bind(this)

      this.detailsEl.addEventListener("pointerenter", this.handlePointerEnter)
      this.detailsEl.addEventListener("pointerleave", this.handlePointerLeave)
    }

    handlePointerEnter() {
      this.detailsEl.open = true
    }

    handlePointerLeave() {
      this.detailsEl.open = false
    }

    disconnectedCallback() {
      this.detailsEl.removeEventListener("pointerenter", this.handlePointerEnter)
      this.detailsEl.removeEventListener("pointerleave", this.handlePointerLeave)
    }
  }

  customElements.define("v-nested-menu", VNestedMenu)

  class VSalePopup extends HTMLElement {
    constructor() {
      super()
      this.SIGNED_UP_EVENT = new Event("sale:signed-up", { bubbles: true })
      this.SIGNED_CANCEL_EVENT = new Event("sale:signed-cancel", { bubbles: true })
      const hasSignedUpForSaleString = localStorage.getItem("SIGNED_UP_FOR_SALE")
      this.hasSignedUpForSale = hasSignedUpForSaleString ? JSON.parse(hasSignedUpForSaleString) : false
      const nextSignedUpPopupTimeString = localStorage.getItem("NEXT_SIGNED_UP_POPUP_TIME")
      this.nextSignedUpPopupTime = nextSignedUpPopupTimeString ? JSON.parse(nextSignedUpPopupTimeString) : Date.now()
    }

    connectedCallback() {
      this.addEventListener("sale:signed-cancel", () => {
        const delay = 10 * 60 * 1000 // 1 day delay
        // const delay = 24 * 60 * 60 * 1000 // 1 day delay
        const nextPopupTime = Date.now() + delay
        localStorage.setItem("SIGNED_UP_FOR_SALE", false)
        localStorage.setItem("NEXT_SIGNED_UP_POPUP_TIME", nextPopupTime)
        document.body.classList.remove("overflow-hidden")
        this.remove()
      })

      this.addEventListener("sale:signed-up", () => {
        localStorage.setItem("SIGNED_UP_FOR_SALE", true)
        document.body.classList.remove("overflow-hidden")
        this.remove()
      })

      this.closeBtn = this.querySelector("button[data-close-btn]")
      this.closeBtn.addEventListener("click", e => {
        e.stopImmediatePropagation()
        this.dispatchEvent(this.SIGNED_CANCEL_EVENT)
      })

      this.dataSuccessHint = this.querySelector("input[data-success-hint]")
      if (this.dataSuccessHint) {
        this.dispatchEvent(this.SIGNED_UP_EVENT)
      }

      setTimeout(() => {
        if (!this.hasSignedUpForSale && Date.now() > this.nextSignedUpPopupTime) {
          this.classList.add("flex")
          this.classList.remove("hidden")
          document.body.classList.add("overflow-hidden")
        }
      }, 5 * 1000)
    }

    disconnectedCallback() {
    }
  }

  customElements.define("v-sale-popup", VSalePopup)

  class VSaleOfferExpiryCounter extends HTMLElement {
    constructor() {
      super()
      this.intervalId
      this.STANDARD_SECONDS_IN_DAY = 24 * 60 * 60 // hours * minutes * seconds
    }

    connectedCallback() {
      this.daysEl = this.querySelector("[data-days]")
      this.hoursEl = this.querySelector("[data-hours]")
      this.minutesEl = this.querySelector("[data-minutes]")
      this.secondsEl = this.querySelector("[data-seconds]")
      this.timeEl = this.querySelector("time")
      this.endDateInSeconds = (new Date(this.timeEl.getAttribute("datetime"))).getTime() / 1000


      const updateTimer = () => {
        const diffSeconds = this.endDateInSeconds - (Date.now() / 1000)
        const remainingDays = Math.floor((diffSeconds - this.STANDARD_SECONDS_IN_DAY) / 60 / 60 / 24)

        const currentDate = new Date()
        const currentHour = currentDate.getHours()
        const currentMinutes = currentDate.getMinutes()
        const currentSeconds = currentDate.getSeconds()

        let remainingHours = (24 - currentHour - 1) % 24
        remainingHours = remainingHours < 10 ? "0" + remainingHours : remainingHours

        let remainingMinutes = (60 - currentMinutes) % 60
        remainingMinutes = remainingMinutes < 10 ? "0" + remainingMinutes : remainingMinutes

        let remainingSeconds = (60 - currentSeconds) % 60
        remainingSeconds = remainingSeconds < 10 ? "0" + remainingSeconds : remainingSeconds

        this.daysEl.innerText = remainingDays
        this.hoursEl.innerText = remainingHours
        this.minutesEl.innerText = remainingMinutes
        this.secondsEl.innerText = remainingSeconds
      }

      updateTimer()

      this.intervalId = setInterval(updateTimer, 1000)

    }

    disconnectedCallback() {
      clearInterval(this.intervalId)
    }
  }

  customElements.define("v-sale-offer-expiry-counter", VSaleOfferExpiryCounter)

  class VImageGallery extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      this.carousel = this.querySelector("[data-carousel]")

      this.clickHandler = this.clickHandler.bind(this)
      this.handleMousemove = this.handleMousemove.bind(this)
      this.handleMouseenter = this.handleMouseenter.bind(this)
      this.handleMouseleave = this.handleMouseleave.bind(this)

      this.carousel.addEventListener("click", this.clickHandler, true)
      this.carousel.addEventListener("mousemove", this.handleMousemove)

      const allFirstProductImages = this.carousel.querySelectorAll("[data-slide] > img:first-child")
      allFirstProductImages.forEach(firstProductImage => {

        firstProductImage.addEventListener("mouseenter", this.handleMouseenter)
        firstProductImage.addEventListener("mouseleave", this.handleMouseleave)
      })
    }

    removeLightbox() {
      document.removeEventListener("keydown", this.keydownListener)
      this.newLightbox.remove()
    }

    clickHandler(e) {
      if (
        e.target.tagName.toLowerCase() === "img"
        || e.target.tagName.toLowerCase() === "model-viewer"
      ) {
        this.openLightbox.bind(this)(e)
      }
    }

    handleMouseenter(e) {
      const nextImg = e.target.nextElementSibling
      if (nextImg.tagName.toLowerCase() !== "img") return;

      nextImg.style.opacity = 1
    }

    handleMouseleave(e) {
      const nextImg = e.target.nextElementSibling
      if (nextImg.tagName.toLowerCase() !== "img") return;

      nextImg.style.opacity = 0
    }

    handleMousemove(e) {
      if (e.target.tagName.toLowerCase() !== "img") return;
      const img = e.target
      const nextImg = img.nextElementSibling

      if (nextImg.tagName.toLowerCase() !== "img" && !nextImg.hasAttribute("data-preview")) {
        this.createPreviewImg(img)
        return;
      }

      const { offsetX, offsetY } = e
      const { width: imgWidth, height: imgHeight } = img.getBoundingClientRect()
      const { width: previewImgWidth, height: previewImgHeight } = nextImg.getBoundingClientRect()

      const widthDiff = previewImgWidth - imgWidth
      const widthDiffPercent = widthDiff / imgWidth

      const heightDiff = previewImgHeight - imgHeight
      const heightDiffPercent = heightDiff / imgHeight

      const offsetXPercent = offsetX * widthDiffPercent
      const offsetYPercent = offsetY * heightDiffPercent

      // nextImg.style.top = -offsetYPercent + "px"
      // nextImg.style.left = -offsetXPercent + "px"
      nextImg.style.transform = `translateX(${-offsetXPercent}px) translateY(${-offsetYPercent}px)`
    }

    createPreviewImg(img) {
      this.previewImg = document.createElement("img")
      const scale = 1.5
      const width = img.width * scale + "px"
      const height = img.height * scale + "px"
      const newImageSrcWidth = Number((new URLSearchParams(img.currentSrc)).get("width")) * scale

      this.previewImg.src = img.currentSrc.split("?")[0] + "?width=" + newImageSrcWidth
      this.previewImg.style.width = width;
      this.previewImg.style.height = height;
      this.previewImg.style.position = "absolute"
      this.previewImg.style.top = "0px"
      this.previewImg.style.left = "0px"
      this.previewImg.style.pointerEvents = "none"
      this.previewImg.style.maxWidth = "none"
      this.previewImg.className = "block object-cover rounded-lg"

      this.previewImg.setAttribute("data-preview", "")
      img.insertAdjacentElement("afterend", this.previewImg)
    }

    openLightbox(e) {
      e.stopImmediatePropagation()
      let width = window.innerWidth
      if (window.innerHeight < window.innerWidth) width = window.innerHeight;
      width = width - 24 * 2 // removing the padding

      let focusItem;

      if (e.target.tagName.toLowerCase() === "img") {
        const img = e.target
        const src = img.src.split("?")[0] + "?width=" + width
        focusItem = `<img src="${src}" width="${width}" height="${width}" class="block object-cover w-full h-full rounded-lg" />`
      } else if (e.target.tagName.toLowerCase() === "model-viewer") {
        const clonedModelViewer = e.target.cloneNode(true)
        focusItem = clonedModelViewer.outerHTML
      }

      const newLightboxTemplate = `
          <div class="fixed top-0 left-0 flex justify-center items-center p-6 rounded-lg z-[999999] w-full h-full bg-primary-600/80 backdrop-blur-[6px]">
            <div class="relative flex items-center justify-center" style="width: ${width}px; height: ${width}px">
              ${focusItem}

            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-8 cursor-pointer aspect-square absolute top-2 right-2 bg-primary-25 p-1 rounded-full  text-primary-600 hover:text-primary-25 hover:bg-primary-600 transition-all duration-300">
              <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" stroke="currentColor" class="transition-all duration-300" />
              <path d="M15 16L9 8" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" stroke="currentColor" class="transition-all duration-300" />
              <path d="M9 16L15 8" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" stroke="currentColor" class="transition-all duration-300" />
            </svg>
          </div>

            <style>
              body {
                overflow: hidden;
              }
            </style>
          </div>
          `
      const htmlParser = new DOMParser()
      this.newLightbox = htmlParser.parseFromString(newLightboxTemplate, "text/html").body.firstElementChild

      document.body.appendChild(this.newLightbox)

      this.keydownListener = (e) => {
        if (e.code.toLowerCase() === "escape") {
          this.removeLightbox()
        }
      }

      document.addEventListener("keydown", this.keydownListener)

      this.newLightbox.addEventListener("click", (e) => {
        if (e.target.tagName.toLowerCase() === "img" || e.target.tagName.toLowerCase() === "model-viewer") return;
        this.removeLightbox()
      })
    }

    disconnectedCallback() {
      this.carousel.removeEventListener("click", this.clickHandler)
    }
  }

  customElements.define("v-image-gallery", VImageGallery)

  class VProuctImageCard extends HTMLElement {
    constructor() {
      super()
      this.hasVideo
      this.videoUrl
      this.secondImageTag
      this.video
    }

    connectedCallback() {
      this.hasVideo = this.hasAttribute("data-has-video")
      if (!this.hasVideo) return;
      this.createAddVideo = this.createAddVideo.bind(this)
      this.handleMouseenter = this.handleMouseenter.bind(this)
      this.handleMouseleave = this.handleMouseleave.bind(this)

      this.parentElement.addEventListener("mouseenter", this.handleMouseenter)
      this.parentElement.addEventListener("mouseleave", this.handleMouseleave)
    }

    handleMouseenter() {
      if (this.hasVideo && !this.video) {
        this.createAddVideo()
      } else {
        this.video.play()
      };
    }

    handleMouseleave() {
      if (this.hasVideo && this.video) {
        this.video.pause()
      };
    }

    createAddVideo() {
      this.videoUrl = this.dataset.videoUrl
      this.secondImageTag = this.querySelectorAll("img")[1]

      this.video = document.createElement("video")
      this.video.src = this.videoUrl
      this.video.className = "aspect-square absolute top-0 left-0 h-full opacity-0 group-hover:opacity-100"
      this.video.muted = true
      this.video.autoplay = true
      this.video.loop = true
      this.secondImageTag.insertAdjacentElement("afterend", this.video)
    }

    disconnectedCallback() {
      this.parentElement.removeEventListener("mouseenter", this.handleMouseenter())
      this.parentElement.removeEventListener("mouseleave", this.handleMouseleave())
    }
  }

  customElements.define("v-product-image-card", VProuctImageCard)

  window.addEventListener("contextmenu", (e) => e.preventDefault())
  window.addEventListener("copy", (e) => e.preventDefault())
  window.addEventListener("cut", (e) => e.preventDefault())
  // window.addEventListener("pointerdown", (e) => e.preventDefault())
  window.addEventListener("selectstart", (e) => e.preventDefault())
  window.addEventListener("dragstart", (e) => e.preventDefault())

  window.addEventListener("keydown", (e) => {
    const didPressCtrl = e.ctrlKey
    const didPressMeta = e.metaKey // command key for mac and window key for linux and windows
    const didPressShift = e.shiftKey
    const didPressAlt = e.altKey
    const code = e.code.toLowerCase()
    const key = code.replace("key", "")

    const ctrlShiftKeys = ["i", "j", "k", "c"]
    const ctrlAltKeys = ["i", "j", "k", "c", "u"]
    const ctrlKeys = ["u"]
    const funcKeys = ["f12"]

    if (didPressCtrl && didPressShift && ctrlShiftKeys.includes(key)) return e.preventDefault();
    if (didPressMeta && didPressShift && ctrlShiftKeys.includes(key)) return e.preventDefault();
    if (didPressCtrl && didPressAlt && ctrlAltKeys.includes(key)) return e.preventDefault();
    if (didPressMeta && didPressAlt && ctrlAltKeys.includes(key)) return e.preventDefault();
    if (didPressCtrl && ctrlKeys.includes(key)) return e.preventDefault();
    if (funcKeys.includes(key)) return e.preventDefault();

    /*
========== Window/Linux Shortcuts ==========
F12
Ctrl + Shift + I
Ctrl + Shift + J (opens console directly)
Ctrl + Shift + K (console directly)
Ctrl + Shift + C
Ctrl + U
========== MacOS Shortcuts ==========
Cmd + Option + I
Cmd + Option + J (console directly)
Cmd + Option + K (console directly)
Cmd + Shift + C (element inspector)
Cmd + Option + U
    */
  })

  // close the redirection popup
  const popupDiv = document.querySelector("#redirection-popup")
  const popupBtns = [...popupDiv.querySelectorAll("button.redirection-popup-button")]

  popupBtns.forEach(
    popupBtn => {
      popupBtn.addEventListener("click", _ => {
        popupDiv.remove()
      })
    }
  )
})()
